import React from 'react';
import {Footer, Header} from "../../index";
import {Box, Flex, useBreakpointValue} from "@chakra-ui/react";
import { ReactComponent as Left} from "../../../assets/icons/authLeftBlur.svg";
import { ReactComponent as Right} from "../../../assets/icons/authRightBlur.svg";
import { ReactComponent as Bottom} from "../../../assets/icons/authBottomBlur.svg";

const BackgroundImages = () => (
    <>
        <Box
            zIndex={'1'}
            maxW={'910px'}
            maxH={'513px'}
            left={'-158px'}
            top={'116px'}
            opacity={'70%'}
            position={'absolute'}>
            <Left />
        </Box>
        <Box
            zIndex={'1'}
            maxW={'910px'}
            maxH={'513px'}
            right={'0'}
            top={'415px'}
            opacity={'70%'}
            position={'absolute'}>
            <Right />
        </Box>
        <Box
            zIndex={'1'}
            maxW={'596px'}
            maxH={'336px'}
            left={'597px'}
            bottom={'0'}
            opacity={'70%'}
            position={'absolute'}>
            <Bottom />
        </Box>
    </>
)

const AuthLayout = ({children, footer = false}) => {
    const isMobile = useBreakpointValue({ base: true, md : false, lg: false })

    return (
        <Flex
            bg={'dark'}
            overflow={'hidden'}
            minH={'100vh'}
            flexDirection={'column'}
            position={'relative'}>
            <Header />
            <Box flex={'1'}>{children}</Box>
            {!isMobile && <BackgroundImages />}
            {footer && <Footer />}
        </Flex>
    );
};

export default AuthLayout;